var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOvalRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 12 12",
    width: 10,
    height: 10,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SMS-Manager-v6",
    transform: "translate(-928.000000, -1687.000000)",
    fill: "#DD705E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(80.000000, 1385.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(57.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 796,
    cy: 307,
    r: 5,
    vectorEffect: "non-scaling-stroke"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvalRed);
export default __webpack_public_path__ + "static/media/Oval-red.803fba2face5b547b238ea1674b8fe5b.svg";
export { ForwardRef as ReactComponent };